'use client';

import dynamic from 'next/dynamic';
import { useEffect, useRef } from 'react';

import AccordionDuvidasFallback from '@/components/organisms/AccordionDuvidas/fallback';
import FormDuvidasFallback from '@/components/organisms/FormDuvida/fallback';
import useBreakpoint, { breakpointDesktopDefault } from '@/hooks/useBreakpoint';
import { registrarEvento } from '@/services/googleAnalytics';

const AccordionDuvidas = dynamic(
  () => import('@/components/organisms/AccordionDuvidas'),
  {
    ssr: false,
    loading: () => <AccordionDuvidasFallback />,
  },
);

const FormDuvida = dynamic(() => import('@/components/organisms/FormDuvida'), {
  ssr: false,
  loading: () => <FormDuvidasFallback />,
});

export default function Ajuda() {
  const { breakpoint } = useBreakpoint();
  const itensVisualizados = useRef<Set<string>>(new Set());

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        const visiveisIds = entries
          .filter((entry) => entry.isIntersecting)
          .map((entry) => entry.target.id);

        const novosItens = visiveisIds.filter(
          (itemId) => !itensVisualizados?.current.has(itemId),
        );

        if (novosItens.length === 0) return;

        novosItens.forEach((itemId) => itensVisualizados?.current.add(itemId));

        registrarEvento(
          `verticalPaginaAjudaLane${novosItens[novosItens.length - 1] || ''}`,
          {},
        );
      },
      { threshold: 0.5 },
    );

    const elementos = document.querySelectorAll('.observavel');

    elementos.forEach((el) => observer.observe(el));

    return () => observer.disconnect();
  }, []);

  return (
    <div
      style={
        breakpoint === 'desktop'
          ? { ...breakpointDesktopDefault, maxWidth: 900 }
          : {}
      }
    >
      <AccordionDuvidas />
      <FormDuvida />
    </div>
  );
}
